import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CallStage } from 'src/app/enums/CallStage';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-report-titles',
  templateUrl: './report-titles.component.html',
  styleUrls: ['./report-titles.component.scss']
})
export class ReportTitlesComponent implements OnInit {
  talentfilterdata: any = {};
  aggregatescount: number = 50;
  totalCount: number = 0;
  @ViewChild('titlesort') titlesort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count', '%total','totalTenure', 'topemployers'];

  currentPage: number = 1;
  pageSize: number = 10;
  totalResultCount: any
  currentjobtitledata:any[] = []
  currentjobtitles: any
  start: number = 0;
  end: number = 10;
  titlesarray: any[] = [];
  isApiCalled: boolean = false;
  subscriptions: Array<Subscription> = [];
  /**Sorted data of visible pages */
  titlesSortData:any;
  /**top employers data loaded */
  hasTopEmployer: boolean = false;

  insightsExportSubscription: Subscription = null;

  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }
  jobtitledataAI: any

  constructor(
    private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService, private router: Router,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService
  , private talentInsightsService: TalentInsightsService) { }

  ngOnInit(): void {
    // const titlessubscription = this.personsearchservice.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(titlessubscription);

    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.hasTopEmployer = false;
    this.getcurrentjobtitles();
    this.personsearchservice.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)
  }


  getcurrentjobtitles() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle-total_tenure_median';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
      this.isApiCalled = true;
      this.totalResultCount = response.data.totalresultscount;

       const tempData = response.data.aggregations['current_jobtitle-total_tenure_median'];
       this.titlesarray = _.pluck(tempData, 'key')
       tempData.map(res=>{
        res.total_tenure = res.total_tenure_median.value != null ? res.total_tenure_median.value: 0;
        return res;
      });
        this.titlesSortData = tempData;
        this.totalCount = tempData.length;
        this.currentjobtitledata = tempData.slice(this.start, this.end);

        this.currentjobtitles = new MatTableDataSource(this.currentjobtitledata);
        this.currentjobtitles.sort = this.titlesort;
        this.gettopemployers();
        this.manualSort();
        this.getindustriesdataai(this.titlesSortData)
     });
  }

  getjobtitlepercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  manualSort() {
    this.reSortArr(this.titlesort)
  }
  reSortArr(sort){
    const tempData = this.titlesSortData;

    if(!sort || !sort.active || sort.direction === ''){
      this.currentjobtitledata = tempData.slice(this.start, this.end);
      this.currentjobtitles = new MatTableDataSource(this.currentjobtitledata);
      this.currentjobtitles.sort = this.titlesort;
      return;
    }

    this.titlesSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'totalTenure': return this.compare(a.total_tenure, b.total_tenure, isAsc);
        default: return 0;
      }
    });

    this.currentjobtitledata = this.titlesSortData.slice(this.start, this.end);
    this.currentjobtitles = new MatTableDataSource(this.currentjobtitledata);
    this.currentjobtitles.sort = this.titlesort;   
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getcurrentjobtitles();
    }
    else{
      this.manualSort();
    }
   
  }

  gettopemployers() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_jobtitle-current_company";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
      this.hasTopEmployer = true;
       const tempData = response.data.aggregations['current_jobtitle-current_company'];
       this.titlesSortData.map(res=>{
        const companies = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim());
        if(companies.length > 0) {
          res.companynames = _.pluck(companies[0].job_company_name.buckets, 'key').join(', ');
          return res;
        }
       })   
       this.getindustriesdataai(this.titlesSortData)  
     });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;

    const additionalFilters = {};
    switch(type) {
      case 'jobtitle': additionalFilters['mandatoryjobtitles'] = [key]; break;
    }

    this.talentfilterdata['additionalFilters'] = additionalFilters;
    // this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.personsearchservice.setTalentinsights(this.talentfilterdata);
    // this.router.navigate(['/person/search/listing'], { queryParams: { 'redirectSource': 'talent-insights' } })
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  getindustriesdataai(data) {
    let titlesdata: any;
    titlesdata = data.map(x=>{
      let res: any ={};
      res['Titles'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getjobtitlepercentage(x.doc_count)+'%';
      res['Top Employers'] = x.companynames;
      res['Median Overall Exp'] = Math.round(x.total_tenure * 100) / 100 + 'yrs'
      ;
      return res;
    
    })
    this.jobtitledataAI = {
      jobtitles: titlesdata
    }
    if(titlesdata.length == 0)
    this.jobtitledataAI = null;
  }
  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'titles') return;

    const payloadForInsightsExport = {
      tab: 'titles',
      totalresultcount: this.totalResultCount,
      titles: this.titlesSortData
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

}
